import React from 'react';
import DocumentList from '../../components/Documents/DocumentList';

const Documents = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <DocumentList />
    </div>
  );
};

export default Documents;


